// https://tarekraafat.github.io/autoComplete.js/#/configuration
import autoComplete from "@tarekraafat/autocomplete.js"

export default () => ({
  autocomplete: null,
  init(){
    // fill autocomplete options
    // https://github.com/alpinejs/alpine/blob/main/packages/alpinejs/src/evaluator.js#L61
    const optionsEvaluator = new Function(`return ${this.$el.getAttribute('options')}`)
    const options = {
      data: {
        src: [],
        keys: []
      },
      ...optionsEvaluator(),
    }

    // set relative container
    this.$el.style.position = 'relative'
    // init
    const configs = {
      ...options,
      selector: () => this.$el.querySelector('input'),
      resultsList: {
        ...options.resultsList,
        class: 'autocomplete-list',
      },
      resultItem: {
        ...options.resultItem,
        selected: 'selected',
      }
    }

    this.autocomplete = new autoComplete(configs)

    // dropdown direction
    this.$el.addEventListener('open', () => {
      // calc direction on open
      const select = this.$root.querySelector('ul.autocomplete-list')
      const yPos = select.getBoundingClientRect().y
      const selectHeight = select.getBoundingClientRect().height
      select.dataset.direction = yPos + selectHeight > window.innerHeight ? 'top' : 'bottom'
    })
    this.$el.addEventListener('close', () => {
      // reset direction
      const select = this.$root.querySelector('ul.autocomplete-list')
      delete select.dataset.direction
    })
  }
})